import { EStatus, ILike } from '../../types/likes';

const getNewCount = {
  [EStatus.Disliked]: {
    [EStatus.Disliked]: (like: ILike) => ({ dislikesCount: like.dislikesCount, likesCount: like.likesCount }),
    [EStatus.Liked]: (like: ILike) => ({
      dislikesCount: Math.max(0, like.dislikesCount - 1),
      likesCount: like.likesCount + 1,
    }),
    [EStatus.Unknown]: (like: ILike) => ({
      dislikesCount: Math.max(0, like.dislikesCount - 1),
      likesCount: like.likesCount,
    }),
  },
  [EStatus.Liked]: {
    [EStatus.Disliked]: (like: ILike) => ({
      dislikesCount: like.dislikesCount + 1,
      likesCount: Math.max(0, like.likesCount - 1),
    }),
    [EStatus.Liked]: (like: ILike) => ({ dislikesCount: like.dislikesCount, likesCount: like.likesCount }),
    [EStatus.Unknown]: (like: ILike) => ({
      dislikesCount: like.dislikesCount,
      likesCount: Math.max(0, like.likesCount - 1),
    }),
  },
  [EStatus.Unknown]: {
    [EStatus.Disliked]: (like: ILike) => ({ dislikesCount: like.dislikesCount + 1, likesCount: like.likesCount }),
    [EStatus.Liked]: (like: ILike) => ({ dislikesCount: like.dislikesCount, likesCount: like.likesCount + 1 }),
    [EStatus.Unknown]: (like: ILike) => ({ dislikesCount: like.dislikesCount, likesCount: like.likesCount }),
  },
};
export function mapLikeAndDislikeReaction({ currentState, nextState }: { currentState: ILike; nextState: EStatus }) {
  try {
    return {
      status: nextState,
      ...getNewCount[currentState.status][nextState](currentState),
    };
  } catch (e) {
    return currentState;
  }
}
